export function SET_PRODUCT_ID(state, productId) {
  state.productIdSelected = productId;
}

export function SET_BIOASSAY(state, item) {
  state.bioassaySelected = item;
}
